export default "__VITE_ASSET__CD$c9FQ2__"